/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import config from '../coreFIles/config'
import Header from '../directives/header'
import '../component/Mrmintnew/css/pages/Blog.css'
import 'react-accessible-accordion/dist/fancy-example.css';
import Carousel from 'react-bootstrap/Carousel';
import { getuserBlogAction, getUserBlogSliderAction } from '../Action/user.action';
import { Col, Row } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import axios from 'axios';
import Footer from './Mrmintnew/directives/footer';
const Blognew = () => {
  const [getuserbloglist, setuserBlogList] = useState([]);
  const [getuserblogsliderlist, setuserBlogSliderList] = useState([]);

  useEffect(() => {
    getuserBlog();
    getuserBlogslider();
  }, []);

  const getuserBlog = async () => {
    let res = await getuserBlogAction();

    if (res.success) {
      setuserBlogList(res.data)
    }
  }

  const getuserBlogslider = async () => {
    let res = await getUserBlogSliderAction();
    if (res.success) {
      setuserBlogSliderList(res.data)
    }
  }

  const imageArray = [
    "images/Mr Mint Revamp - Final/Group 126807.png",
    "images/Mr Mint Revamp - Final/Group 126808.png",
    "images/Mr Mint Revamp - Final/Group 126809.png",
    "images/Mr Mint Revamp - Final/Group 126810.png",
    "images/Mr Mint Revamp - Final/Group 126811.png"
  ]

  const currentUrl = window.location.href;

  // const [ eventdata, setEventdata ] = useState()

  // const geteventData = async () => {
  //   try {
  //     const eventdata = axios({
  //       method: 'get',
  //       url: "https://fakestoreapi.com/products/category/jewelery",
  //       responseType: 'stream'
  //     })

  //     eventdata.then((res) => {
  //       console.log("res.data", res.data);
  //       setEventdata(res.data)
  //     }).catch((error) => {
  //       console.log('res.data', error)
  //       setEventdata(error)
  //     }
  //     )
  //   } catch (error) {
  //     setEventdata(error)
  //   }
  // }

  // console.log("eventdata", eventdata);

  // useEffect(() => {
  //   geteventData()
  // }, [])


  return (

    <>
      <Helmet>
        <link rel="canonical" href={currentUrl} />
        <title>Explore the Best Crypto Blogs at Mr Mint | Cryptocurrency Topics</title>
        <meta name="keywords"
          content="Best crypto blogs for beginners, Cryptocurrency blogs in India, Cryptocurrency blog topics, top cryptocurrency topics, Interesting cryptocurrency topics" />
        <meta name="description" content="Learn the safest crypto investment options with Mr Mint’s Blog. Get expert tips on secure cryptocurrency investments and make smart choices with us today!" />

      </Helmet>
      <Header />
      <div id="content">
        <div className="breadcrumb-wrap bg-f br-4">
          <div className="overlay bg-black op-7" />
          <div className="container">
            <div className="breadcrumb-title">
              <h1 className='text-center blog_font'>Blog</h1>
              <ul className="breadcrumb-menu list-style text-center">
                <li>
                  <a href="#">Home</a>
                </li>
                <li>Blog</li>
              </ul>
            </div>
          </div>
        </div>
        <section className='blog-info-title pt-5'>
          <div className='container'>
            <p>
              Stay up to date with the latest stories and commentary brought to you by Mr Mint, the World's 1st Token Backed By Crypto Mining Ecosystem.
            </p>
          </div>
        </section>


        <section className='carousel-blog pt-0 pb-0'>
          <div className='container'>
            <Carousel>
              {getuserblogsliderlist.map(item => (
                <Carousel.Item>
                  <div className='row'>
                    <div className="col-lg-6">
                      <a href={`${config.baseUrl}blog/` + item.title_url} className='mr-read-more'>
                        <img className="d-block w-100" src={`${config.imageUrl + item.slider_image}`} alt="First slide" />
                      </a>
                    </div>
                    <div className="col-lg-6">
                      <div>
                        <h3 className='blog_font'>
                          <a href={`${config.baseUrl}blog/` + item.title_url} className='mr-read-more'>
                            {parseInt(item.title.split(' ').filter(word => word !== '').length) > 8 ? item.title.split(/\s+/).slice(0, 8).join(" ") + '...' : item.title}
                          </a>
                        </h3>
                        <p>

                          {parseInt(item.description.split(' ').filter(word => word !== '').length) > 30 ?
                            <>
                              <div dangerouslySetInnerHTML={{ __html: item.description.split(/\s+/).slice(0, 30).join(" ") + '...' }} />
                            </>
                            :
                            <div dangerouslySetInnerHTML={{ __html: item.description }} />
                          }
                        </p>
                      </div>
                    </div>
                  </div>
                </Carousel.Item>
              ))}
            </Carousel>
          </div>
        </section>

        <section className="mr-blog-block pt-5">
          <div className="container">
            <div className='mr-blog-list'>


              <Row className='my-5'>
                {getuserbloglist.map((data, index) => {
                  return <Col md={6} lg={4} className='mb-4'>
                    <div className='blog_card'>
                      <div className='blog_img_wrapper'>
                        <img src={`${config.imageUrl + data.image}`} className='blog_img' alt="blog card image's" />
                        {/* <img src={imageArray[index]} className='blog_img' alt="blog card image's" /> */}
                      </div>

                      <div className='m-3'>
                        <h4>{data.blog_type == 1 ?
                          <span>Blog</span>
                          :
                          <span>Upcoming Events</span>
                        }</h4>

                        <p className='blog_heading my-3'>
                          <span>{data.title.length > 60 ?
                            data.title.substring(0, 60) + `....`
                            :
                            data.title
                          }</span></p>

                        <p>
                          <a href={`${config.baseUrl}blog/` + data.title_url} className='mr-read-more blog_btn'>
                            Read More
                            <i className="fa fa-long-arrow-right ms-1" aria-hidden="true"></i>
                          </a>
                        </p>
                      </div>
                    </div>
                  </Col>
                })}
              </Row>

              {/* <div className="row">
                {getuserbloglist.map(data => (
                  <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6">
                    <div className="mr-blog-item">
                      <div className="mr-item-inner">
                        <div className="mr-imgbox-block text-center">
                          <img src={`${config.imageUrl + data.image}`} alt="Image" className='w-auto' />
                        </div>
                      </div>
                      <div className="mr-blog-description">
                        <div className='mr-bog-top'>
                          <span className="mr-blog-cat">
                            <>
                              {data.blog_type == 1 ?
                                <span>Blog</span>
                                :
                                <span>Upcoming Events</span>
                              }
                            </>

                          </span>
                          <h4 className='my-3'>
                            {data.title.length > 60 ?
                              data.title.substring(0, 60) + `....`
                              :
                              data.title
                            }
                          </h4>
                          <p>
                            <a href={`${config.baseUrl}blog/` + data.title_url} className='mr-read-more'>
                              Read More
                              <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}

              </div> */}
            </div>
          </div>
        </section>
      </div >
      <Footer />
    </>
  )
}
export default Blognew;